<script lang="ts" setup>
import { useDisplay } from "vuetify";
const { mobile } = useDisplay();
</script>

<template lang="pug">
v-dialog(
  transition="dialog-bottom-transition"
  :fullscreen="mobile"
)
  template(v-slot:activator="{ props }")
    slot(
      name="dialog-activator"
      v-bind="props"
    )
  template(v-slot:default="{ isActive }")
    v-row
      v-col
        v-card(
          flat
          class="mx-auto"
          width="400"
        )
          template(v-slot:append)
            v-btn(
              icon="mdi-close"
              variant="text"
              @click="isActive.value = false"
            )
          v-card-text(

          )
            v-row(justify="space-around")
              v-col(cols="12")
                v-img(
                  src='/images/runnding-dog.jpg'
                )
            v-row
              v-col
                h3(class="text-center ma-3") 申し訳ございません
                p(class="text-center text-body-2")
                  | 地図表示機能は現在は開発中です。
                  | 地図からペット同伴可の施設を探せるようになります。
                  | 乞うご期待くださいませ。

</template>

<style lang="scss" scoped>
.v-label {
  color: rgba(
    var(--v-theme-on-surface),
    var(--v-high-emphasis-opacity)
  ) !important;
}
</style>
